import {useEventData} from './useEventData'

export const useOrderFromEvent = (eventId: number, orderId: number) => {
  const eventQuery = useEventData(eventId)
  let order

  if (!eventQuery.isLoading && !eventQuery.isError) {
    order = eventQuery?.data?.orders.find((o: any) => o.id === orderId)
  }

  return {
    ...eventQuery,
    order,
  }
}
